<template>
  <div class="home">
    <el-scrollbar style="height: 100%">
      <page-header />
      <div class="home__body">
        <div class="home__body__platform">
          <div class="home__body__platform__header">
            <div class="home__body__platform__title">央馆AI科学实验</div>
            <div class="home__body__platform__description">
              ——AI大模型赋能实验教学提质，助力每一所学校开好科学课！
            </div>
            <div class="home__body__platform__download">
              <div class="home__body__platform__download__item">
                <button
                class="home__body__platform__download__item__btn-primary"
                @click="handleDownload">
                  前往下载
                </button>
                <div class="home__body__platform__download__item__desc">
                  <p>{{ appPackageInfo }}</p>
                  <p>支持{{ platform.support }}</p>
                </div>
              </div>
              <div class="home__body__platform__download__item">
                <button
                class="home__body__platform__download__item__btn-secondary" @click="handleOpen">
                  已安装，立即打开
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="video-container">
          <div class="video-container__inner">
            <video width="100%" height="100%" :src="videoUrl" loop controls muted autoplay controlslist="nodownload noremoteplayback noplaybackrate" disablePictureInPicture="true"></video>
            <!-- <videoPreview :url="videoUrl" :auto-play="true"
                    url-type="mp4"
                    :is-show="true" /> -->
          </div>
        </div>
        <div class="home__body__software">
          <img class="home__body__software__left" src="@/assets/images/home/bg-left.png" />
          <TitleWithDecoration title="数字化实验设备" />
          <div class="home__body__software__main">
            <div class="home__body__software__card" v-for="(item,index) in softwareList" :key="index" :style="{backgroundImage: `url(${item.bg})`}">
              <img class="home__body__software__card__img" :src="item.icon" />
              <div class="home__body__software__card__main">
                <div class="home__body__software__card__title">
                  {{ item.title }}
                </div>
                <div class="home__body__software__card__desc" v-html="item.desc">
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="home__body__course">
          <TitleWithDecoration title="体系化实验课程" />
          <div class="home__body__course__index">
            <img
            alt=""
            src="@/assets/images/home/course-index.png"
          />
          </div>
          <div class="home__body__course__main">
            <div v-for="(item, index) in courseList" :class="['home__body__course__card', 'home__body__course__card__'+index]" :key="index" :style="{backgroundImage: `url(${item.bg})`}">
              <div class="home__body__course__card__title">
                  {{ item.title }}
                </div>
                <div class="home__body__course__card__desc" v-html="item.desc">
                </div>
              </div>
          </div>
        </div>
        <div class="home__body__device">
          <TitleWithDecoration title="智能化教学软件" />
          <div class="home__body__device__body">
            <div class="home__body__device__main">
              <div v-for="(item, index) in deviceList"  :class="['home__body__device__card', 'home__body__device__card__'+index]" :key="index">
                <div class="home__body__course__card__title">
                    {{ item.title }}
                  </div>
                  <div class="home__body__course__card__desc" v-html="item.desc">
                  </div>
              </div>
            </div>
          </div>
        </div>
        <div class="home__body__case">
          <TitleWithDecoration title="应用案例" />
          <div class="home__body__case__main">
            <CaseList :case-list="caseList" height="400px" />
          </div>
        </div>
        <div class="home__body__link" v-if="concatInfo">
          <span>联系方式：</span>{{ concatInfo }}
        </div>
      </div>
      <div class="home__footer">
        <div class="home__footer__first">
          <span class="home__footer__first__left">教育部教育技术与资源发展中心（中央电化教育馆）</span>
          <span class="home__footer__first__right">保留所有权利，未经允许不得复制、镜像</span>
        </div>
        <div class="home__footer__second">
          <a class="home__footer__second__left" target="_blank" rel="noreferrer" href="https://beian.miit.gov.cn/#/Integrated/index">京ICP备09059518号-10</a>
          <a class="home__footer__second__right" href="https://beian.mps.gov.cn/#/query/webSearch?code=11010202010141" target="_blank" rel="noreferrer">京公网安备11010202009831号</a>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { byteChange, getFormateDateString } from "@/utils";
import TitleWithDecoration from "@/components/TitleWithDecoration";
import CaseList from "@/components/caseList";
import PageHeader from "@/components/pageHeader";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
// import videoPreview from "@/components/videoPreview";
export default {
  name: "Home",
  components: {
    TitleWithDecoration,
    CaseList,
    PageHeader
    // videoPreview
  },
  data() {
    return {
      platform: {
        url: "-",
        support: "WIN7及以上",
        size: "-",
        updateTime: "-"
      },
      platformError: [],
      browserId: "", // 浏览器指纹
      checkTimer: null, // 轮询定时器
      maxRetries: 10, // 最大重试次数
      currentRetry: 0, // 当前重试次数
      checkInterval: 1000, // 轮询间隔(ms)
      softwareList: [
        {
          icon: require("@/assets/images/home/software-card1.png"),
          bg: require("@/assets/images/home/software-card-bg1.png"),
          title: "高精度传感器",
          desc: "解决手动误差，精准捕捉动态数据，<br/>培养学生科学实证思维"
        },
        {
          icon: require("@/assets/images/home/software-card2.png"),
          bg: require("@/assets/images/home/software-card-bg2.png"),
          title: "科学实验器",
          desc: "改良传统教具，模拟复杂现象， <br/>提升实验效果和探究深度"
        },
        {
          icon: require("@/assets/images/home/software-card3.png"),
          bg: require("@/assets/images/home/software-card-bg3.png"),
          title: "全场景探究设备",
          desc: "无线便携设计， <br/>支持从教室到户外多场景探究， <br/>打破实验空间限制"
        }
      ],
      courseList: [
        {
          bg: require("@/assets/images/home/course-card-bg1.png"),
          title: "课标必做实验课程",
          desc: "满足课标实验要求， <br/>助力基础教学高质量落地"
        },
        {
          bg: require("@/assets/images/home/course-card-bg2.png"),
          title: "跨学科项目式课程",
          desc: "结合真实情境，培养学生创新实践能力"
        },
        {
          bg: require("@/assets/images/home/course-card-bg3.png"),
          title: "基础+拓展双轨设计",
          desc: "必做实验完整覆盖、拓展实验创新赋能，<br/>适配多元教学场景，助力学校打造特色"
        }
      ],
      deviceList: [
        {
          title: "备授课一体工具",
          desc: "融合课件、实验和互动组件， <br/>一体化设计实现备授课无缝衔接"
        },
        {
          title: "课堂智能中枢",
          desc: "学生实验数据自动采集分析，<br/>教师实时掌握全班实验动态，<br/>对比分析更高效"
        },
        {
          title: "AI全流程助手",
          desc: "智能助教、智能学伴、智能管理，<br/>AI赋能实验教学全场景，减轻教师负担"
        }
      ],
      caseList: [
        {
          id: 1,
          image: require("@/assets/images/case/case1_1.png"),
          title: "安徽省合肥青年路小学教育集团黄河路小学——争取让每个孩子，都有机会做“小小科学家”",
          description: "数字化实验设备突破了传统实验的时空限制，使复杂的实验更容易开展，促进了跨学科融合与创新思维的培养。”学校科学老师沐璟玮在接收中国教育电视台采访时说道"
        },
        {
          id: 2,
          image: require("@/assets/images/case/case2_1.jpeg"),
          title: "杭州市滨文小学——比起成果，我们更想谈谈为什么要重视“AI+科学实验”",
          description: "余嘉辉老师的《测量水沸腾和结冰时的温度》被评为浙江省省级实验教学类“基础教育精品课”。<br/>基于校内实验案例输出的论文《人工智能助力科学实验教学实践创新》在《中国信息技术教育》杂志正式发表。"
        },
        {
          id: 3,
          image: require("@/assets/images/case/case3_3.png"),
          title: "浙江省教育科学研究院附属小学——用AI撬动从“枯桑”到“沃野”的科学实验创新之路",
          description: "基于数字化传感器套件搭建多模态数据驱动评价的科学实践课程《解锁桑树种植密码》成功入选《2025智能教育发展蓝皮书》优秀案例。"
        },
        {
          id: 4,
          image: require("@/assets/images/case/case4_1.jpeg"),
          title: "温州市龙湾区天河镇第一小学——让每个孩子都能成为“沸腾现场”的主角",
          description: "过去上《水沸腾了》，学生大多数只能观察到水沸腾的结果，AI数字化设备突破了水沸腾实验‘只见结果难观过程’的局限，更加直观、有趣。”温州市龙湾区天河第一小学涂黎娜老师上完公开课后说道。"
        }
      ],
      loadingInstance: null,
      videoUrl: "",
      concatInfo: ""
    };
  },
  computed: {
    appPackageInfo() {
      return `${this.platform.size} 更新时间: ${this.platform.updateTime}`;
    },
    downloadConfigs() {
      return window.shield.ShieldConfig.braveCfg.downloadConfigs;
    },
    footerText() {
      return window.shield.ShieldConfig.braveCfg.footerText;
    }
  },
  created() {
    this.videoUrl = window.shield.ShieldConfig.braveCfg.customParams[0].videoUrl;
  },
  async mounted() {
    // 生成浏览器指纹
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    this.browserId = result.visitorId;

    this.getVersion("yg_aiscience_flagship_pc");
    this.getLink();
    // 检查 URL 参数，如果 type=open 且有 code，直接调用 openPc
    const open = window.localStorage.getItem("open");
    const code = window.localStorage.getItem("code");
    if (open === "1") {
      // 延迟执行，确保组件完全初始化
      this.$nextTick(() => {
        this.openPc(code);
      });
    }
  },
  beforeDestroy() {
    // 清理轮询定时器
    if (this.checkTimer) {
      clearInterval(this.checkTimer);
    }
    if (this.loadingInstance) {
      this.loadingInstance.close();
      this.loadingInstance = null;
    }
  },
  methods: {
    handleClientMessage(event) {
      // 这里可以加 event.origin 校验安全性
      if (event.data) {
        console.log("event::", event.data);
      }
    },
    async getLink() {
      try {
        const {data} = await this.$request({
          url: "Version -> getContactInfo",
        });
        this.concatInfo = data;
      } catch (err) {
        this.concatInfo = '';
        console.log("Error::", err);
      }
    },
    async getVersion(platform) {
      try {
        const res = await this.$request({
          url: "Version -> getVersion",
          data: {
            platform: platform
          }
        });
        const { fileSize, updateTime, url } = res.data;
        const size = fileSize && byteChange(fileSize);
        const _updateTime = updateTime && getFormateDateString(updateTime, "/");
        const _url = url;
        const _info = {
          size,
          updateTime: _updateTime,
          url: _url
        };
        this.platform = {
            ...this.platform,
            ..._info
          };
      } catch (err) {
        console.log("Error::", err);
        this.platformError.push(platform);
      }
    },
    handleDownload() {
      const url = this.platform.url;
      if (!url || url === "-") {
        this.$message.error("未获取到下载地址！");
        return;
      }
      const a = document.createElement("a");
      a.href = url;
      a.target = "_self";
      a.click();
      a.remove();
    },
    handleToLogin() {
      const ygAuthUrl = window.shield.ShieldConfig.braveCfg.customParams[0].ygAuthUrl;
      // const type = new URLSearchParams(window.location.search).get("type");
      window.location.href = ygAuthUrl;
    },
    // 生成序列号
    generateSeq() {
      return Date.now().toString();
    },

    // 检查是否已唤起
    async checkLaunchStatus(seq) {
      try {
        const res = await this.$request({
          url: "User -> getWakeUpFlag",
          data: {
            clientType: "pc-ygkxsy",
            browserId: this.browserId,
            seq: seq
          }
        });

        if (res.data) {
          // 已唤起，停止轮询
          clearInterval(this.checkTimer);
          this.currentRetry = 0;
          if (this.loadingInstance) {
            this.loadingInstance.close();
            this.loadingInstance = null;
          }
          this.$message.success("客户端已成功启动！");
          return true;
        }

        // 增加重试次数
        this.currentRetry++;
        if (this.currentRetry >= this.maxRetries) {
          // 超过最大重试次数，停止轮询
          clearInterval(this.checkTimer);
          this.currentRetry = 0;
          if (this.loadingInstance) {
            this.loadingInstance.close();
            this.loadingInstance = null;
          }
          this.$message.error("当前您已取消打开应用或者尚未下载软件。");
          return false;
        }

        return false;
      } catch (err) {
        console.log("Error::", err);
        clearInterval(this.checkTimer);
        this.currentRetry = 0;
        if (this.loadingInstance) {
          this.loadingInstance.close();
          this.loadingInstance = null;
        }
        this.$message.error("检查启动状态失败，请稍后重试");
        return false;
      }
    },

    // 开始轮询检查
    startPolling(seq) {
      this.currentRetry = 0;
      // 显示 loading
      this.loadingInstance = this.$loading({
        lock: true,
        text: "正在检测客户端启动状态...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)"
      });
      this.checkTimer = setInterval(() => {
        this.checkLaunchStatus(seq);
      }, this.checkInterval);
    },

    openPc(code) {
      try {
        // 生成seq
        const seq = this.generateSeq();

        // 拼接协议
        const protocol = "ygaiscience://open";
        const params = new URLSearchParams({
          browserId: this.browserId,
          seq: seq
        });
        if (code) {
          params.append("code", code);
        }
        const finalUrl = `${protocol}?${params.toString()}`;

        // 启动轮询检查
        this.startPolling(seq);

        // 唤起应用
        window.location.href = finalUrl;
        window.localStorage.removeItem("open");
        window.localStorage.removeItem("code");

      } catch (err) {
        console.log("Error::", err);
        if (this.checkTimer) {
          clearInterval(this.checkTimer);
        }
        if (this.loadingInstance) {
          this.loadingInstance.close();
          this.loadingInstance = null;
        }
        this.$message.error("当前您尚未下载软件，请先下载软件以便正常使用各项功能。");
      }
    },
    handleOpen() {
      const linkCode = window.localStorage.getItem("code");
      if (!linkCode) {
        this.$message({
          message: "登录信息加载中，请稍后重新尝试",
          type: "warning",
          duration: 3000,
          onClose: () => {
            this.handleToLogin();
          }
        });
      } else {
        this.openPc(linkCode);
      }
    }
  }
};
</script>

<style lang="scss">
.home {
  --page-padding: 368px;
  --primary-gradient: linear-gradient(90deg, #3366FF -2%, #3188F6 37%, #2EC7E6 100%);
  --hover-shadow: 0 0.08rem 0.2rem 0 rgba(90, 144, 248, 0.3);
  background: #ffffff;
  height: 100%;
  &__body {
    overflow: auto;
    margin-top: 60px;
    &__platform {
      background: url("~@/assets/images/home/science-bg.png") no-repeat
        center/cover;
      height: 480px;
      padding: 0 var(--page-padding) 0 var(--page-padding);
      &__header {
        float: right;
        right: 170px;
        margin-top: 134px;

        text-align: left;
      }
      &__title {
        font-size: 40px;
        font-weight: normal;
        line-height: normal;
        color: #262626;
      }
      &__description {
        font-size: 22px;
        font-weight: normal;
        letter-spacing: normal;
        color: #595959;

        margin-top: 2px;
      }
      &__download {
        display: flex;
        gap: 16px;
        margin-top: 40px;
        &__item {
          width: 216px;
          display: flex;
          flex-direction: column;
          &__btn-primary {
            width: 100%;
            height:48px;
            border-radius: 8px;
            color: #ffffff;
            border: none;
            background: var(--primary-gradient);

            font-size: 16px;
            font-weight: 600;
            line-height: normal;
            text-align: center;
            letter-spacing: normal;
            color: #FFFFFF;
          }
          &__btn-secondary {
            width: 100%;
            height:48px;
            border-radius: 8px;
            background: #F3FAFF;
            border: 1px solid #3188F6;
            font-size: 16px;

            font-weight: 500;
            line-height: normal;
            text-align: center;
            background: linear-gradient(90deg, #3366FF -2%, #3188F6 37%, #2EC7E6 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }
          &__desc {
            margin-top: 12px;
            font-size: 12px;
            font-weight: normal;
            line-height: 14px;
            letter-spacing: normal;
            color: #8C8C8C;
            text-align: center;
          }
        }
      }
    }

    &__software {
      padding: 36px 0 57px 0;
      position: relative;
      &__left {
        position: absolute;
        left: 0;
        top: 8px;
        width: 136px;
        height:277px;
      }

      &__main {
        display: flex;
        justify-content: center;
        margin-top: 40px;

      }
      &__card {
          width: 390px;
          height: 158px;
          padding:25px 19px;

          display: flex;
          &+.home__body__software__card {
            margin-left: 30px;
          }

          &__main{
            padding:8px 0;
          }
          &__img {
            width: 88px;
            height: 88px;
            margin-right: 12px;
          }
          &__title {
            font-size: 18px;
            font-weight: 600;
            line-height: 20px;
            letter-spacing: normal;
            color: #262626;
          }

          &__desc{
            margin-top: 8px;
            font-size: 14px;
            font-weight: normal;
            line-height: 24px;
            text-align: left;
            color: #595959;
          }
        }
    }

    &__course {
      padding-top:50px;
      padding-bottom: 80px;
      background: #F8FEFF;
      &__index {
        margin-top: 54px;
        display: flex;
        justify-content: center;
      }
      &__main {
        margin-top: 19px;

        display: flex;
        justify-content: center;
      }
      &__card {
        width: 320px;
        height: 134px;
        padding:27px 32px;
        border-radius: 8px;
        border: 2px solid #FFFFFF;
        background-size: 100% 100%;

        &+.home__body__course__card {
          margin-left: 32px;
        }

        &__title {
          font-size: 18px;
          font-weight: 600;
          line-height: 20px;
          letter-spacing: normal;
          color: #262626;
        }

        &__desc {
          margin-top: 12px;
          font-size: 14px;
          font-weight: normal;
          line-height: 24px;
          letter-spacing: normal;
          color: #595959;
        }

      }
    }

    &__device {
      padding:46px 0 96px 0;
      background: #FFFFFF;
      &__body {
        margin-top: 61px;
        display: flex;
        justify-content: center;
      }

      &__main {
        background: url("~@/assets/images/home/device-main.png") no-repeat center center;
        background-size: cover;
        width:1064px;
        height: 158px;
        display: flex;
        box-sizing: border-box;

        padding:32px 0;

      }
      &__card {
        &__0 {
          margin-left: 113px;
          width:225px;
        }
        &__1 {
          margin-left: 100px;
          width:239px;
          height: 158px;
        }
        &__2 {
          margin-left: 100px;
          width: 392px;
          height: 158px;
        }

        &__title {
          font-size: 18px;
          font-weight: 500;
          line-height: 20px;
          color: #262626;
        }

        &__desc {
          margin-top: 15px;
          font-size: 14px;
          font-weight: normal;
          line-height: 24px;
          color: #595959;
        }

      }
    }

    &__case {
      padding: 50px 0 160px 0;
      background: linear-gradient(180deg, #F4F5F7 0%, rgba(244, 245, 247, 0) 100%);
      &__main {
        margin-top: 40px;
        padding: 0 0;
      }
    }

    &__link {
        display: flex;
        align-items: center;
        justify-content: center;
      
        margin: 0 auto 30px auto;

        font-size: 18px;
        font-weight: normal;
        line-height: 24px;
        text-align: center;
        color: #595959;


    }
  }
  &__footer {
    width: 100%;
    background: #38415B;
    color: #fff;
    padding: 21px 0;
    display: flex;
    flex-direction: column;

    font-size: 14px;
    font-weight: normal;
    line-height: normal;
    text-align: center;
    color: #FFFFFF;


    &__first {
      opacity: 0.67;

      &__left {
        text-align: left;
        width:322px;
        display: inline-block;
      }

      &__right {
        text-align: left;
        margin-left: 14px;
        width:308px;
        display: inline-block;
      }
    }

    &__second {
      margin-top: 10px;
      opacity: 0.67;
      &__left {
        min-width:152px;
        display: inline-block;
        font-size: 14px;
        font-weight: normal;
        line-height: normal;
        text-align: left;
        color: #FFFFFF;
      }

      &__right {
        margin-left: 14px;
        min-width:191px;
        display: inline-block;
        font-size: 14px;
        font-weight: normal;
        line-height: normal;
        text-align: left;
        color: #FFFFFF;
      }
    }
  }
  .el-scrollbar__wrap {
    margin-bottom: 0.06rem !important;
    margin-right: -0.06rem !important;
    overflow-x: hidden;
    scrollbar-width: none; // 不设置此项firefox会出现原始滚动条
  }
  .el-scrollbar__bar.is-horizontal {
    display: none;
  }
}

.video-container {
  margin-top: 14px;
  display: flex;
  justify-content: center;
  &__inner {
    height: 586px;
    width:1042px;

  }
}
</style>
